import { atom } from 'recoil';

export const eyeTestState = atom({
  key: 'eyeTestState',
  default: {
    isInit: true,
    currentStep: 0,
    isCompleted: false,
    formValue: '',
    fullSuccess: false,
  },
});
